import { strategyApi, STRATEGY_TEMPLATES_TAG } from './strategyApi';
import { CriteriaTemplate } from 'src/components/DynamicCriteriaGenerator/types/criteriaTemplate';
import { buildSearchParamsAuto } from '../utils';

interface GetTemplatesParams {
  type: string; // Strategy type like 'SCOUT_LIST', 'PATIENT_JOURNEY', etc.
}

interface GetTemplatesResponse {
  results: CriteriaTemplate[];
}

export const strategyTemplatesApi = strategyApi.injectEndpoints({
  endpoints: (builder) => ({
    getStrategyTemplates: builder.query<CriteriaTemplate[], GetTemplatesParams>(
      {
        query: ({ type }) => {
          const queryParams = buildSearchParamsAuto({ type });
          const queryString = queryParams.toString();

          return {
            url: `v1/strategies/templates/?${queryString}`,
          };
        },
        transformResponse: (response: GetTemplatesResponse) => response.results,
        providesTags: (result, error, { type }) => [
          { type: STRATEGY_TEMPLATES_TAG, id: type },
        ],
      }
    ),
  }),
});

export const { useGetStrategyTemplatesQuery } = strategyTemplatesApi;
